import { CurrencyCircleDollar, ReadCvLogo } from '@phosphor-icons/react';
import { useEffect, useState } from 'react';
import AnnualPreviewDropdown from '../components/AnnualPreviewDropdown';
import AnnualPreviewInvoiceItem from '../components/AnnualPreviewInvoiceItem';
import AnnualPreviewInfoItem from '../components/AnnualPreviewInfoItem';
import AnnualPreviewItemDropdown from '../components/AnnualPreviewItemDropdown';
import { AnnualPreviewData } from '../../../@types/AnnualPreview.type';

const AnnualPreviewStep2 = ({
	data,
	userHasAnnualSubscription,
}: {
	data: AnnualPreviewData;
	userHasAnnualSubscription: boolean;
}) => {
	const [showDropdown, setShowDropdown] = useState<any>(() => {
		const initialState: Record<string, boolean> = {
			deductibles: false,
		};

		// Inicializar los estados para cada régimen
		data.incomes.detail_incomes.forEach((_, index) => {
			initialState[`income_${index}`] = false;
		});

		return initialState;
	});

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	return (
		<div className='flex flex-col gap-4'>
			{data.incomes.detail_incomes.map((item, indexContainer) => (
				<AnnualPreviewDropdown
					key={indexContainer}
					isOpen={showDropdown[`income_${indexContainer}`]}
					toggleOpen={() =>
						setShowDropdown({
							...showDropdown,
							[`income_${indexContainer}`]:
								!showDropdown[`income_${indexContainer}`],
						})
					}
					label={`Ingresos - ${item.regime}`}
					total={item.invoices.reduce(
						(acc, invoice) => acc + invoice.income,
						0,
					)}
					icon={<CurrencyCircleDollar />}
				>
					<div>
						<div className='flex flex-col gap-4 md:gap-8'>
							<div className='flex flex-col gap-2'>
								{item.invoices.map((invoice, index) => (
									<AnnualPreviewInvoiceItem
										key={invoice?.income + index}
										index={index}
										label={invoice.issuer}
										firstValue={{
											label: 'Ingreso',
											value: invoice.income,
										}}
									/>
								))}
							</div>
						</div>
						<div className='flex flex-col gap-2 mt-4 text-xs md:text-sm'>
							<AnnualPreviewInfoItem
								label={`Total Ingresos`}
								value={item.invoices.reduce(
									(acc, invoice) => acc + invoice.income,
									0,
								)}
							/>
						</div>
					</div>
				</AnnualPreviewDropdown>
			))}
			<AnnualPreviewDropdown
				isOpen={showDropdown.deductibles}
				toggleOpen={() =>
					setShowDropdown({
						...showDropdown,
						deductibles: !showDropdown.deductibles,
					})
				}
				total={data?.result?.total_deductions}
				label='Deducciones personales'
				icon={<ReadCvLogo />}
			>
				{data?.deductibles?.length > 0 ? (
					<div className='flex flex-col gap-2'>
						{data.deductibles.map((item, index) => {
							return (
								<AnnualPreviewItemDropdown
									key={index}
									deductibles={item}
									index={index}
								/>
							);
						})}
					</div>
				) : (
					<div className='bg-gradient-to-tr from-h-primary-90/80 to-h-primary-90/20 rounded-lg border border-h-primary-100 p-4 shadow-sm my-3 pb-6 text-h-dark'>
						<div className='flex flex-col items-center gap-3'>
							<ReadCvLogo
								size={28}
								weight='duotone'
								className='text-h-primary'
							/>
							<a
								href='https://noticias.heru.app/en/articles/5360705'
								target='_blank'
								className='font-bold  text-center leading-tight'
							>
								{userHasAnnualSubscription ? (
									<>
										Estamos revisando <br /> posibles deducciones personales
										dentro tus gastos en el 2024
									</>
								) : (
									<>
										No se encontraron deducciones personales <br />
										dentro tus gastos en el 2024
									</>
								)}
							</a>
							{userHasAnnualSubscription ? (
								<p className='text-center text-sm leading-tight font-light mt-1'>
									Aplicaremos todas las deducciones personales que encontremos
									en tus CFDIs.
								</p>
							) : (
								<p className='text-center text-sm leading-tight font-light mt-1'>
									Pero no te preocupes,{' '}
									<span className='font-medium'>
										al contratar tu plan de Declaración Anual
									</span>
									, haremos una búsqueda exhaustiva de deducciones en todos tus
									CFDIs.
								</p>
							)}
						</div>
					</div>
				)}
			</AnnualPreviewDropdown>
		</div>
	);
};

export default AnnualPreviewStep2;
